import Text19 from './Text19'
export default Text19
